import {
    type ComponentType,
    createContext,
    useContext,
    useEffect,
    type FC
} from "react";
import type {
    MessageGroupContextType,
    MessagePartContentProps,
    MessageContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const MessageContext = createContext<MessageContextType | null>(null);

export const MessageGroupContext = createContext<MessageGroupContextType | null>(null);

export const useMessageContext = () => {
    return useContext(MessageContext);
};

export const useMessageGroupContext = () => {
    return useContext(MessageGroupContext);
};

export const withMessageContext = <P extends object>(
    part: string,
    Content: ComponentType<MessagePartContentProps<P>>
): FC<P> => {
    const MessagePart: FC<P> = (props) => {
        const context = useMessageContext();

        useEffect(() => {
            if(context) {
                return;
            }

            warnOnce({
                message: `Message.${part}: it must be rendered inside a Message.`
            });
        }, [
            context
        ]);

        if(!context) {
            return null;
        }

        return <Content
            {...props}
            context={context}
        />;
    };

    MessagePart.displayName = `Message.${part}`;

    return MessagePart;
};
